import { createModel } from '@/store/tools';

const model = {
    namespace: 'banktransaction',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getIncomeDrawTypeList': T('getIncomeDrawTypeList'),
            'getTransactionNameList': T('getTransactionNameList'),
            'getTransactionList': T('getTransactionList'),
        },
        actions: {
            'getIncomeDrawTypeList': A('getIncomeDrawTypeList'),
            'getTransactionNameList': A('getTransactionNameList'),
            'getTransactionList': A('getTransactionList'),
        },
        sagas: {
            'getIncomeDrawTypeList': S('getIncomeDrawTypeList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getTransactionNameList': S('getTransactionNameList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getTransactionList': S('getTransactionList', '/?cmd=com.xqxc.api.pig.mis.pay.WithdrawalMisService.unionWalletTransDetail'),
        },
        reducers: {
            'incomeDrawTypeList': R('getIncomeDrawTypeList', []),
            'transactionNameList': R('getTransactionNameList', []),
            'transactionList': R('getTransactionList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
        }
    })
};
export default createModel(model);